module.exports = {
          srcSet: __webpack_public_path__ + "img/135ac71-20.png"+" 20w",
          images:[ {path: __webpack_public_path__ + "img/135ac71-20.png",width: 20,height: 6}],
          src: __webpack_public_path__ + "img/135ac71-20.png",
          toString:function(){return __webpack_public_path__ + "img/135ac71-20.png"},
          placeholder: undefined,
          width: 20,
          height: 6
      }